import React from "react";
import { _ } from "lodash";
import { toUnicode } from "../../../utils/DomainUtils";
import AppConfig from "../../../config/app";
import DesignUtils from "../../../utils/DesignUtils";
import styles from "./SiteSettingsModal.module.css";

const SiteInformationProperties = ({ siteSettings }) => {
  const { protocol } = window.location;
  let publishDomainProtocol = protocol;

  const subdomain = siteSettings.getIn(["site", "subdomain"], false);
  const wwwRequired = siteSettings.getIn(["site", "domain_info", "www_required"], false);
  const sslRequired = siteSettings.getIn(["site", "domain_info", "ssl_enabled"], false);
  const customDomain = siteSettings.getIn(["site", "domain"], false);

  const subDomainName = _.isEmpty(subdomain)
    ? DesignUtils.encodeKeyForSubdomain(siteSettings.getIn(["site", "key"]))
    : subdomain;

  const siteDomain = `${subDomainName}.${AppConfig.siteDomain}`;

  let publishDomain = _.isEmpty(customDomain) ? siteDomain : customDomain;
  publishDomain = (wwwRequired ? "www." : "") + publishDomain;
  publishDomainProtocol = sslRequired ? "https:" : "http:";
  return (
    <>
      <div className={styles.urlContainer}>
        <div>Publish URL</div>
        <a
          className={styles.urlLink}
          href={`${publishDomainProtocol}//${toUnicode(publishDomain || "")}`}
          title={toUnicode(publishDomain)}
          target="_blank"
          rel="noreferrer"
        >
          {toUnicode(publishDomain || "")}
        </a>
      </div>
      <div className={styles.urlContainer}>
        <div>Vanity URL</div>
        <a
          className={styles.urlLink}
          href={`${protocol}//${siteDomain}`}
          title={siteDomain}
          target="_blank"
          rel="noreferrer"
        >
          {siteDomain}
        </a>
      </div>
      <div className={styles.urlContainer}>
        <div>Preview URL</div>
        <a
          className={styles.urlLink}
          href={`${protocol}//${subDomainName}.${AppConfig.previewDomain}`}
          title={`${subDomainName}.${AppConfig.previewDomain}`}
          target="_blank"
          rel="noreferrer"
        >
          {`${subDomainName}.${AppConfig.previewDomain}`}
        </a>
      </div>
    </>
  );
};

export default SiteInformationProperties;
